const s = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/kswps", "application/kswpt", "application/vnd.openxmlformats-officedocument.wordprocessingml.template", "application/vnd.ms-word.document.macroEnabled.12", "application/vnd.ms-word.template.macroEnabled.12"], c = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.spreadsheetml.template", "text/csv", "text/csv; charset=utf-8", "application/vnd.ms-excel.sheet.binary.macroEnabled.12", "application/vnd.ms-excel.sheet.macroEnabled.12", "application/vnd.ms-excel.template.macroEnabled.12", "application/kset", "application/ksett"], m = ["application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.template", "application/vnd.openxmlformats-officedocument.presentationml.slideshow", "application/ksdps", "application/ksdpt", "application/vnd.ms-powerpoint.presentation.macroEnabled.12", "application/vnd.ms-powerpoint.template.macroEnabled.12", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"], r = ["text/lrc", "text/asp; charset=utf-8", "application/x-msdownload", "text/richtext; charset=utf-8", "text/plain", "text/plain; charset=utf-8", "text/xml", "text/html", "text/html; charset=utf-8", "text/markdown"], l = ["text/x-c; charset=utf-8", "text/x-c; charset=utf-8", "text/x-chdr", "text/x-asm; charset=utf-8", "text/x-java-source; charset=utf-8", "text/javascript", "text/x-go"], x = ["image/x-sony-arw", "image/bmp", "image/vnd.zbrush.pcx", "image/x-pcx", "image/tiff", "image/gif", "image/x-exif", "image/jpeg", "image/vnd.fpx", "image/svg+xml", "image/vnd.adobe.photoshop", "image/x-cdr", "image/x-photo-cd", "image/vnd.dxf", "image/x-ufo", "application/postscript", "image/png", "image/wmf", "image/webp", "image/x-tga"], f = ["audio/mpeg", "audio/aac", "audio/x-flac", "audio/amr", "audio/AMR", "audio/mp4", "audio/x-ms-wma", "audio/x-wav", "audio/x-cd", "audio/x-wave", "audio/x-aiff", "audio/midi", "audio/x-realaudio", "audio/x-twinvq", "audio/ogg", "audio/x-ape", "audio/webm", "audio/mpeg-4"], u = ["video/mp4", "video/3gpp", "video/x-ms-asf", "video/x-msvideo", "video/dv", "video/x-flv", "video/x-f4v", "application/vnd.apple.mpegurl", "video/x-matroska", "video/quicktime", "video/mpeg", "video/mp2t", "application/vnd.rn-realmedia", "audio/x-pn-realaudio", "video/x-ms-wmv", "video/dat"], h = ["application/zip", "application/vnd.rar", "application/x-compress"], w = ["application/vnd.ms-visio.drawing", "application/x-visio", "application/vnd.ms-visio.drawing.main+xml"], g = ["application/vnd.pos"], d = {
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  wps: "application/kswps",
  wpt: "application/kswpt",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  docm: "application/vnd.ms-word.document.macroEnabled.12",
  dotm: "application/vnd.ms-word.template.macroEnabled.12",
  xls: "application/vnd.ms-excel",
  xlm: "application/vnd.ms-excel",
  xla: "application/vnd.ms-excel",
  xlc: "application/vnd.ms-excel",
  xlt: "application/vnd.ms-excel",
  xlw: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  csv: "text/csv",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  xlsm: "application/vnd.ms-excel.sheet.macroEnabled.12",
  xltm: "application/vnd.ms-excel.template.macroEnabled.12",
  et: "application/kset",
  ett: "application/ksett",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ppt: "application/vnd.ms-powerpoint",
  pps: "application/vnd.ms-powerpoint",
  pot: "application/vnd.ms-powerpoint",
  potx: "application/vnd.openxmlformats-officedocument.presentationml.template",
  ppsx: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  dps: "application/ksdps",
  dpt: "application/ksdpt",
  pptm: "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
  potm: "application/vnd.ms-powerpoint.template.macroEnabled.12",
  ppsm: "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
  lrc: "text/lrc",
  asp: "text/asp; charset=utf-8",
  txt: "text/plain",
  html: "text/html",
  md: "text/markdown",
  c: "text/x-c; charset=utf-8",
  cpp: "text/x-c; charset=utf-8",
  h: "text/x-chdr",
  asm: "text/x-asm; charset=utf-8",
  s: "text/x-asm; charset=utf-8",
  java: "text/x-java-source; charset=utf-8",
  js: "text/javascript",
  go: "text/x-go",
  raw: "image/x-sony-arw",
  bmp: "image/bmp",
  pcx: "image/x-pcx",
  tiff: "image/tiff",
  gif: "image/gif",
  exif: "image/x-exif",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  fpx: "image/vnd.fpx",
  svg: "image/svg+xml",
  psd: "image/vnd.adobe.photoshop",
  cdr: "image/x-cdr",
  pcd: "image/x-photo-cd",
  dxf: "image/vnd.dxf",
  ufo: "image/x-ufo",
  eps: "application/postscript",
  png: "image/png",
  wmf: "image/wmf",
  webp: "image/webp",
  tga: "image/x-tga",
  mp3: "audio/mpeg",
  acc: "audio/aac",
  flac: "audio/x-flac",
  amr: "audio/AMR",
  m4b: "audio/mp4",
  m4a: "audio/mp4",
  wma: "audio/x-ms-wma",
  wav: "audio/x-wav",
  cd: "audio/x-cd",
  wave: "audio/x-wave",
  aiff: "audio/x-aiff",
  midi: "audio/midi",
  ra: "audio/x-realaudio",
  vqf: "audio/x-twinvq",
  ogg: "audio/ogg",
  ape: "audio/x-ape",
  weba: "audio/webm",
  mpeg: "audio/mpeg",
  "mpeg-4": "audio/mpeg-4",
  mp4: "video/mp4",
  "3gp": "video/3gpp",
  asf: "video/x-ms-asf",
  asx: "video/x-ms-asf",
  avi: "video/x-msvideo",
  dv: "video/dv",
  flv: "video/x-flv",
  f4v: "video/x-f4v",
  m3u8: "application/vnd.apple.mpegurl",
  mkv: "video/x-matroska",
  qt: "video/quicktime",
  mov: "video/quicktime",
  mpg: "video/mpeg",
  mts: "video/mp2t",
  m4v: "video/mp4",
  rmvb: "application/vnd.rn-realmedia",
  rm: "audio/x-pn-realaudio",
  wmv: "video/x-ms-wmv",
  dat: "video/dat",
  zip: "application/zip",
  rar: "application/vnd.rar",
  z: "application/x-compress",
  pdf: "application/pdf",
  vsdx: "application/vnd.ms-visio.drawing",
  vsd: "application/vnd.ms-visio.drawing",
  pos: "application/vnd.pos",
  xmind: "application/vnd.pos"
}, D = /* @__PURE__ */ (() => {
  const a = {};
  return Object.entries(d).forEach(([e, p]) => {
    a[p] || (a[p] = []), a[p].push(e);
  }), a;
})();
var o;
(function(a) {
  a.Doc = "application/vnd.tdocs-apps.doc", a.Sheet = "application/vnd.tdocs-apps.sheet", a.Form = "application/vnd.tdocs-apps.form", a.Folder = "application/vnd.tdocs-apps.folder", a.CollaborationSpace = "application/vnd.tdocs-apps.collaboration-space", a.CollaborationSpaceRoot = "application/vnd.tdocs-apps.collaboration-space-root", a.SharedFolder = "application/vnd.tdocs-apps.shared-folder", a.Share = "application/vnd.tdocs-apps.share-folder", a.Slide = "application/vnd.tdocs-apps.slide", a.Pdf = "application/pdf", a.Aio = "application/vnd.tdocs-apps.aio", a.SmartCanvas = "application/vnd.tdocs-apps.smartcanvas", a.SmartSheet = "application/vnd.tdocs-apps.smartsheet", a.Mind = "application/vnd.tdocs-apps.mind", a.FlowChart = "application/vnd.tdocs-apps.flowchart", a.Rec = "application/vnd.tdocs-apps.rec", a.Word = "application/vnd.ms-word", a.Excel = "application/vnd.ms-excel", a.Powerpoint = "application/vnd.ms-powerpoint";
})(o || (o = {}));
var t;
(function(a) {
  a[a.Doc = 0] = "Doc", a[a.Sheet = 1] = "Sheet", a[a.Form = 2] = "Form", a[a.Folder = 3] = "Folder", a[a.Slide = 4] = "Slide", a[a.Pdf = 6] = "Pdf", a[a.Aio = 7] = "Aio", a[a.SmartCanvas = 8] = "SmartCanvas", a[a.Unknown = 10] = "Unknown", a[a.SmartSheet = 9] = "SmartSheet", a[a.Mind = 90] = "Mind", a[a.Flowchart = 91] = "Flowchart", a[a.FlowChart = 91] = "FlowChart", a[a.Drive = 101] = "Drive", a[a.Rec = 102] = "Rec";
})(t || (t = {}));
var i;
(function(a) {
  a.Doc = "doc", a.Sheet = "sheet", a.Slide = "slide", a.Form = "form", a.Pdf = "pdf", a.Mind = "mind", a.FlowChart = "flowchart", a.Aio = "Aio", a.Folder = "folder", a.SmartCanvas = "smartcanvas", a.SmartSheet = "smartsheet", a.Drive = "drive";
})(i || (i = {}));
var n;
(function(a) {
  a.Video = "video", a.Audio = "audio", a.Image = "image", a.Doc = "doc", a.Zip = "zip", a.Unknown = "unknown";
})(n || (n = {}));
const v = {
  [t.Doc]: o.Doc,
  [t.Sheet]: o.Sheet,
  [t.Slide]: o.Slide,
  [t.Form]: o.Form,
  [t.SmartCanvas]: o.SmartCanvas,
  [t.Mind]: o.Mind,
  [t.FlowChart]: o.FlowChart,
  [t.Rec]: o.Rec,
  [t.Pdf]: o.Pdf,
  [t.Aio]: o.Aio
}, S = [[s, t.Doc], [c, t.Sheet], [m, t.Slide], [[o.Form], t.Form], [[o.SmartCanvas], t.SmartCanvas], [[o.SmartSheet], t.SmartSheet], [[o.Doc], t.Doc], [[o.Sheet], t.Sheet], [[o.Slide], t.Slide], [[o.Mind], t.Mind], [[o.FlowChart], t.FlowChart], [l, t.Doc], [r, t.Doc], [[o.Pdf], t.Pdf], [w, t.FlowChart], [g, t.Mind], [[o.Folder], t.Folder]], k = {
  [i.Doc]: o.Word,
  [i.Sheet]: o.Excel,
  [i.Slide]: o.Powerpoint
}, F = {
  [i.Doc]: o.Doc,
  [i.Sheet]: o.Sheet,
  [i.Slide]: o.Slide,
  [i.Form]: o.Form,
  [i.SmartCanvas]: o.SmartCanvas,
  [i.Mind]: o.Mind,
  [i.FlowChart]: o.FlowChart,
  [i.Pdf]: o.Pdf,
  [i.Aio]: o.Aio
}, b = [[s, i.Drive], [c, i.Drive], [m, i.Drive], [[o.Form], i.Form], [[o.SmartCanvas], i.SmartCanvas], [[o.SmartSheet], i.SmartSheet], [[o.Doc], i.Doc], [[o.Sheet], i.Sheet], [[o.Slide], i.Slide], [[o.Mind], i.Mind], [[o.FlowChart], i.FlowChart], [l, i.Drive], [r, i.Drive], [[o.Pdf], i.Pdf], [w, i.FlowChart], [g, i.Mind], [x, i.Drive], [u, i.Drive], [f, i.Drive]], C = (a) => s.includes(a), M = (a) => c.includes(a), E = (a) => m.includes(a), R = (a) => r.includes(a), q = (a) => l.includes(a), A = (a) => x.includes(a), P = (a) => f.includes(a), j = (a) => u.includes(a), L = (a) => h.includes(a), z = (a) => a === "application/msword", I = (a) => a === "application/vnd.openxmlformats-officedocument.wordprocessingml.document", U = (a) => a === "application/vnd.ms-excel", X = (a) => a === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", O = (a) => a === "application/vnd.ms-powerpoint", V = (a) => a === "application/vnd.openxmlformats-officedocument.presentationml.presentation", W = (a) => /^application\/vnd\.tdocs-apps/i.test(a), Z = (a) => /^application\/vnd\.tdocs-addon/i.test(a), B = (a) => d[a] ? d[a] : (console.warn("unknown extension"), "unknown"), G = (a) => v[a] ? v[a] : (console.warn("unknown docType"), "unknown"), H = (a) => {
  const e = d[a];
  return e ? j(e) ? n.Video : P(e) ? n.Audio : A(e) ? n.Image : C(e) || M(e) || E(e) ? n.Doc : L(e) ? n.Zip : n.Unknown : n.Unknown;
}, J = (a) => {
  for (const [e, p] of S)
    if (e.includes(a))
      return p;
}, K = (a, e = !1) => e ? k[a] || "unknown" : F[a] || "unknown", N = (a) => {
  for (const [e, p] of b)
    if (e.includes(a))
      return p;
  return i.Drive;
};
export {
  f as AudioMimeTypes,
  n as Classify,
  l as CodeMimeTypes,
  t as DocType,
  c as ExcelMimeTypes,
  x as ImageMimeTypes,
  o as MimeType,
  i as PadType,
  m as PowerPointMimeTypes,
  r as TextMimeTypes,
  u as VideoMimeTypes,
  s as WordMimeTypes,
  h as archiveMimeTypes,
  v as docTypeToMimeTypeMap,
  k as drivePadTypeToMimeTypeMap,
  d as extToMimeTypeMap,
  w as flowChatMimeTypes,
  H as getClassifyFromExt,
  J as getDocTypeFromMimeType,
  G as getMimeTypeFromDocType,
  B as getMimeTypeFromExt,
  K as getMimeTypeFromPadType,
  N as getPadTypeFromMimeType,
  Z as isAddon,
  P as isAudioLike,
  q as isCodeLike,
  z as isDOC,
  I as isDOCX,
  M as isExcelLike,
  A as isImageLike,
  W as isOnlineDoc,
  O as isPPT,
  V as isPPTX,
  E as isPowerPointLike,
  R as isTextLike,
  j as isVideoLike,
  C as isWordLike,
  U as isXLS,
  X as isXLSX,
  L as isZipLike,
  S as mimeTypeToDocTypeMap,
  D as mimeTypeToExtMap,
  b as mimeTypeToPadType,
  g as mindMimeTypes,
  F as padTypeToMimeTypeMap
};
//# sourceMappingURL=index.es.js.map
